import cartPaymentAndShipmentHtml from './cartpaymentandshipment.component.html';
import './cartpaymentandshipment.component.scss';

class CartPaymentAndShipmentController {
    constructor($scope, $timeout, CartService) {
        'ngInject';

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.service = CartService;
        this.showCountrySelect = false;
        this.countries = window.countries || ['Polska'];
        this.merge_order_email = '';
    }

    $onInit() {
        this.$scope.$watch(
            () => {
                if (!this.service.summary) return null;

                return this.service.summary;
            },
            (newSummary, oldSummary) => {
                if (!newSummary) return;
                if (!this.service.loaded || this.service.loading) return;

                // New cart value -> refresh payments and shipments
                if (!oldSummary || (oldSummary && newSummary.value_of_products_with_discount != oldSummary.value_of_products_with_discount)) {
                    this.service.loadPayments();

                    if (newSummary.payment_id) {
                        this.service.loadShipments();
                    }

                    return;
                }

                if (oldSummary && newSummary.payment_id && newSummary.payment_id != oldSummary.payment_id) {
                    this.service.loadShipments();
                }
            },
            true
        );
    }

    paymentGroupIsNotEmpty(group) {
        const groupPayments = this.service.payments.filter(payment => payment.group_id == group.id);

        return groupPayments.length > 0;
    }

    setPayment(payment) {
        if (this.service.loading) {
            return;
        }
        this.service.setPayment(payment).then(
            () => {
                this.service.loadShipments();
            }
        );
    }

    get selectedPaymentGroupId() {
        const selectedPayment = this.service.payments.find(payment => payment.id === this.service.summary.payment_id);
        if (!selectedPayment) {
            return null;
        }
        return selectedPayment.group_id;
    }

    setPaymentGroup(paymentGroup) {
        this.service.payments.every(payment => {
            if (payment.group_id === paymentGroup.id) {
                this.setPayment(payment);
                return false;
            }
            return true;
        });
    }

    setShipment(shipment, options = null) {
        this.service.setShipment(shipment, options);
    }

    getCurrentPayment() {
        if (!this.service.summary.payment_id) return null;

        return this.service.payments.filter(payment => payment.id == this.service.summary.payment_id)[0];
    }

    changeCountry() {
        this.service.loadShipments();
    }

    shipmentMergeOrderKeydown($event) {
        if ($event.key === 'Enter') {
            this.setShipmentMergeOrderEmail();
        }
    }

    get mergeOrderEmailPlaceholder() {
        if (this.service.summary.merge_order_email) {
            return this.service.summary.merge_order_email;
        }

        return 'Adres e-mail';
    }

    setShipmentMergeOrderEmail() {
        this.service.setShipmentMergeOrderEmail(this.merge_order_email).then(() => {
            this.merge_order_email = '';
        });
    }
}

let cartPaymentAndShipmentComponent = {
    bindings: {},
    template: cartPaymentAndShipmentHtml,
    controller: CartPaymentAndShipmentController
}

export default cartPaymentAndShipmentComponent;
